// extracted by mini-css-extract-plugin
export default {"wrapper":"Option_wrapper__Ib-+Y","text":"Option_text__V3yJl","active":"Option_active__Ogb41"};